import React from 'react';
import { useRecordContext } from 'react-admin';
import {
  Card,
  CardContent,
  Typography,
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import {
  CheckCircle as CheckCircleIcon,
  Error as ErrorIcon,
  Schedule as ScheduleIcon,
  Info as InfoIcon,
} from '@mui/icons-material';
import { leadImportFields } from '../leadImports.model';

const ProgressLog = ({ record: recordProp, ...props }) => {
  const contextRecord = useRecordContext(props);
  const record = recordProp || contextRecord;

  if (!record) return null;

  if (
    !record[leadImportFields.progressLog] ||
    !Array.isArray(record[leadImportFields.progressLog])
  ) {
    return null;
  }

  const getLogIcon = (type) => {
    switch (type) {
      case 'success':
        return <CheckCircleIcon color="success" />;
      case 'error':
        return <ErrorIcon color="error" />;
      case 'warning':
        return <ScheduleIcon color="warning" />;
      case 'info':
      default:
        return <InfoIcon color="info" />;
    }
  };

  return (
    <Card sx={{ mt: 2 }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Progress Log
        </Typography>
        <List dense>
          {record[leadImportFields.progressLog].map((logEntry, index) => (
            <ListItem key={index} sx={{ pl: 0 }}>
              <ListItemIcon sx={{ minWidth: 36 }}>
                {getLogIcon(logEntry.type)}
              </ListItemIcon>
              <ListItemText
                primary={
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Typography variant="body2" component="span">
                      [{logEntry.timestamp}]
                    </Typography>
                    <Typography variant="body1" component="span">
                      {logEntry.message}
                    </Typography>
                  </Box>
                }
              />
            </ListItem>
          ))}
        </List>
      </CardContent>
    </Card>
  );
};

export default ProgressLog;
